import { interpolate } from '../../utils/interpolate'
import type { DynamicStructure } from '../../utils/interpolate'
import type { BreadcrumbItemProps } from './Breadcrumb'

interface ResolveBreadcrumbTrailParams {
  items?: BreadcrumbItemProps[]
  /**
   * Presente só na variação dinâmica. Ausente, os itens saem como foram
   * escritos — o Breadcrumb estático não interpola.
   */
  structure?: DynamicStructure
}

/**
 * A trilha que a página realmente exibe.
 *
 * Fonte única dos dois componentes e da marcação: o JSON-LD é montado no `_app`,
 * numa passada separada do render, e a única forma de ele descrever o que está
 * na tela é os dois lados derivarem a trilha daqui.
 */
export function resolveBreadcrumbTrail({
  items,
  structure,
}: ResolveBreadcrumbTrailParams): BreadcrumbItemProps[] {
  const visible = items?.filter((item) => item.isActive) ?? []

  if (!structure) return visible

  return visible.map((item) => ({
    ...item,
    text: interpolate({ structure, template: item.text }).text,
    link: interpolate({ structure, template: item.link }).text,
  }))
}
